import { render } from "./ContentBlock.vue?vue&type=template&id=61968629&scoped=true"
import script from "./ContentBlock.vue?vue&type=script&lang=js"
export * from "./ContentBlock.vue?vue&type=script&lang=js"

import "./ContentBlock.vue?vue&type=style&index=0&id=61968629&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61968629"]])

export default __exports__